<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.setariCRM')}} </h4>
        </div>
        <div class="subtypes-section">
            <div class="vselect-container">
                <h5> {{$t('placeholder.alegeTipUser')}} </h5>
                <v-select v-model="selected_role"  @change="changeRole((selected_role) ? selected_role.id : 'Alege Rolul')"  placeholder="Alege Rolul" :options="this.roles" label="translateName"></v-select>
            </div>
            <div v-if="this.showSubtypeInput" class="subtype-container">
                <div class="arrow-indicator">
                    <i class="fas fa-arrow-alt-circle-right"></i>
                </div>
                <h5> {{$t('placeholder.adaugaSubtip')}} </h5>
                <input v-model="subtypeInput" @keyup.enter="addSubtypes()" type="text">
            </div>
        </div>
        <div class="subtype-list-wrapper">
            <div v-for="role in this.roles" :key="role.id" class="section-column">
                <h5> {{$t(`roles.${role.name}`)}} </h5>
                <ul class="subtype-list">
                    <li v-for="(subtype, index) in filterSubtypeByRole(role.id)" :key="index">
                        <div class="subytpe-name"> {{subtype.name}} </div>
                        <span class="remove-item" @click="removeSubtype(subtype.name, subtype.role_id)">
                            <i class="fas fa-times-circle"></i>
                        </span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="save-subtype">
            <button type="button" @click="saveTypeSettings()">
                <i class="fas fa-save"></i>
                {{$t('placeholder.salveaza')}}
            </button>
        </div>
    </div>
</template>
<style scoped>

</style>

<script>
import RoleServices from '../../api-services/roles.service.js'
import CrmSectionServices from '../../api-services/crm_section.service.js'
export default {
  name: 'CrmSectionSettings',
  data () {
    return {
      roles: [],
      selected_role: null,
      subtypes: [],
      showSubtypeInput: false,
      subtypeInput: null,
      subtypeMasterId: null,
      removedSubtype: null,
      toBeInserted: [],
      request: false
    }
  },
  methods: {
    getRoles () {
      RoleServices.getAll()
        .then((response) => {
          // this.roles = response.data.data
          let vm = this
          response.data.data.forEach(function (element) {
            let newElement = Object.assign({}, element)
            newElement.translateName = vm.$t(`roles.${element.name}`)
            vm.roles.push(newElement)
          })
          // let result = obj.map(function (element) {
          //   let newElement = Object.assign({}, element)
          //   newElement.translateName = vm.$t(`roles.${element.name}`)
          //   return newElement
          // })
          // console.log(result)
          // let obj = this.roles
          // for (let i = 0; i < obj.length; i++) {
          //   console.log(obj[i])
          // }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getSubtypes () {
      CrmSectionServices.getAll({ all: 1 })
        .then((response) => {
          this.subtypes = response.data.data
          // console.log(response.data.data, response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    saveTypeSettings () {
      if (this.toBeInserted.length && this.request === false) {
        this.request = true
        CrmSectionServices.create(this.toBeInserted)
          .then((response) => {
            this.toBeInserted = []
            this.subtypeInput = null
            this.$notify({
              group: 'succes',
              type: 'success',
              title: this.$t('txt.succes'),
              text: this.$t('success.subtipuriAdaugate'),
              'animation-type': 'css'
            })
            this.request = false
          })
          .catch((error) => {
            console.log(error)
            this.request = false
          })
      }
    },
    changeRole (id) {
      if (typeof id === 'number') {
        this.showSubtypeInput = true
        this.subtypeMasterId = id
      } else {
        this.showSubtypeInput = false
      }
    },
    addSubtypes () {
      if (this.subtypeInput.trim() !== '' && this.subtypeInput !== null) {
        let check = this.subtypes.find(subtype => subtype.name === this.subtypeInput.trim() && parseInt(subtype.role_id) === parseInt(this.subtypeMasterId))

        if (check === undefined) {
          this.subtypes.push(
            {
              'role_id': this.subtypeMasterId,
              'name': this.subtypeInput.trim()
            }
          )
          this.toBeInserted.push(
            {
              'role_id': this.subtypeMasterId,
              'name': this.subtypeInput.trim()
            }
          )
          this.subtypeInput = ''
        } else {
          let message = `${this.subtypeInput.trim()} a fost deja adaugat in ${this.$t(`roles.${this.selected_role.name}`)}`
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: message,
            'animation-type': 'css'
          })
        }
      }
    },
    filterSubtypeByRole (roleid) {
      return this.subtypes.filter(function (subtype) {
        return parseInt(subtype.role_id) === roleid
      })
    },
    removeSubtype (type, role) {
      this.removedSubtype = this.subtypes.find(subtype => parseInt(subtype.role_id) + subtype.name === role + type)
      this.$delete(this.subtypes, this.subtypes.indexOf(this.removedSubtype))
      if (this.notInTobeInserted(this.removedSubtype)) {
        CrmSectionServices.delete(this.removedSubtype.id)
          .then((response) => {
            this.$notify({
              group: 'succes',
              type: 'success',
              title: this.$t('txt.succes'),
              text: this.$t('success.subtipSters'),
              'animation-type': 'css'
            })
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    notInTobeInserted (object) {
      let check = this.toBeInserted.find(inserting => inserting.id === object.id)
      if (check) {
        return false
      } else {
        return true
      }
    }
  },
  created () {
    this.$store.dispatch('hideLoading')
    this.getRoles()
    this.getSubtypes()
  }
}
</script>
